import { render, staticRenderFns } from "./AvatarsBlock.vue?vue&type=template&id=866b05b0"
import script from "./AvatarsBlock.vue?vue&type=script&lang=js"
export * from "./AvatarsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports